/* GREEN PAWLY – gemeinsame Lieferdatum-Berechnung (eine Regel für Warenkorb, Drawer, Footer).
   Regel (bestätigt 03.10.2026): Bestellung an einem Versandtag bis 12:00 Uhr (Berlin) → Versand am selben Tag,
   sonst am nächsten Versandtag. Zustellung voraussichtlich 1–2 Werktage nach Versand.
   Versand-/Werktage: Mo–Fr ohne gesetzliche Feiertage (bundesweit + NRW, Versand aus Enger).
   CLAUDE.md Regel 7: Lieferzeitangaben ernsthaft kalkuliert – daher „voraussichtlich“ und ein Zeitraum. */
(function () {
  if (window.GPDelivery) return;

  var CUTOFF_MINUTES = 12 * 60;

  function easterSunday(y) { // Gauß/Anonymer gregorianischer Algorithmus
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4,
        f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30,
        i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
        month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(Date.UTC(y, month - 1, day));
  }
  function key(d) { return d.toISOString().slice(0, 10); }
  var cache = {};
  function holidays(y) {
    if (cache[y]) return cache[y];
    var e = easterSunday(y), set = {};
    function add(d) { set[key(d)] = true; }
    function rel(n) { var d = new Date(e.getTime()); d.setUTCDate(d.getUTCDate() + n); return d; }
    [[0, 1], [4, 1], [9, 3], [11, 25], [11, 26]].forEach(function (md) { add(new Date(Date.UTC(y, md[0], md[1]))); }); // Neujahr, 1. Mai, Einheit, Weihnachten
    add(new Date(Date.UTC(y, 10, 1)));            // Allerheiligen (NRW)
    add(rel(-2)); add(rel(1)); add(rel(39)); add(rel(50)); // Karfreitag, Ostermontag, Himmelfahrt, Pfingstmontag
    add(rel(60));                                 // Fronleichnam (NRW)
    cache[y] = set;
    return set;
  }
  function isWorkday(d) {
    var w = d.getUTCDay();
    return w >= 1 && w <= 5 && !holidays(d.getUTCFullYear())[key(d)];
  }
  function nextWorkday(d) {
    var n = new Date(d.getTime());
    do { n.setUTCDate(n.getUTCDate() + 1); } while (!isWorkday(n));
    return n;
  }
  function berlinNow() {
    var p = {};
    new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return { day: new Date(Date.UTC(+p.year, +p.month - 1, +p.day)), minutes: (+p.hour) * 60 + (+p.minute) };
  }

  function estimate() {
    var now = berlinNow();
    var beforeCutoff = isWorkday(now.day) && now.minutes < CUTOFF_MINUTES;
    var ship = beforeCutoff ? now.day : nextWorkday(now.day);
    var from = nextWorkday(ship);
    var to = nextWorkday(from);
    return { ship: ship, from: from, to: to, beforeCutoff: beforeCutoff, minutesLeft: beforeCutoff ? CUTOFF_MINUTES - now.minutes : 0, shipsToday: beforeCutoff };
  }
  function fmt(d, long) {
    return d.toLocaleDateString('de-DE', long ? { weekday: 'long', day: '2-digit', month: '2-digit', timeZone: 'UTC' } : { weekday: 'short', day: '2-digit', month: '2-digit', timeZone: 'UTC' });
  }
  function range() {
    var e = estimate();
    return fmt(e.from) + ' – ' + fmt(e.to);
  }
  function countdown(min) {
    var h = Math.floor(min / 60), m = min % 60;
    return h > 0 ? (m > 0 ? h + ' Std. ' + m + ' Min.' : h + ' Std.') : m + ' Min.';
  }

  window.GPDelivery = { estimate: estimate, format: fmt, range: range, countdown: countdown, isWorkday: isWorkday };
})();
